import React, { Component } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  Row,
  Col,
} from "reactstrap";

import { connect } from "react-redux";

import "./Quotation.scss";
import AllCompareQuotation from "./AllCompareQuotation";
import FiltertRightbar from "./FiltersRightbar";

import {
  getCompareQuotationList,
  SetParams,
  FilterClear,
  FiltersShowRightSidebar,
} from "../../store/CompareQuotation/actions";
import LoadingModel from "../LoadingModel";

class CompareQuotationDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = { FilterToggle: false };
  }
  componentDidMount() {
    this.props.FilterClear();

    this.props.getCompareQuotationList({
      ...this.props.params,
      search: "",
      start_date: "",
      end_date: "",
      userdepartment: "",
      department: "",
      cqitems__product: "",
    });
    this.props.SetParams({
      ...this.props.params,
      search: "",
      start_date: "",
      end_date: "",
      userdepartment: "",
      department: "",
      cqitems__product: "",
    });
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {this.props.loading && (
              <LoadingModel OpenModel={this.props.loading} />
            )}
            <Row>
              <Col lg={12}>
                <Card>
                  <CardHeader className="bg-transparent border-bottom ">
                    <h5 className="card-title-18 pt-2 d-inline-block">
                      Compare Quotation Dashboard
                    </h5>
                    <div className="float-right">
                      <div className="d-inline-block">
                        <Button
                          type="button"
                          color="light"
                          className="waves-effect waves-light d-flex  mr-2"
                          onClick={() => this.props.FiltersShowRightSidebar()}
                        >
                          <i className="mdi mdi-filter"></i>
                          <span className="d-none d-lg-block ml-1">
                            Filters
                          </span>
                        </Button>
                      </div>
                      <Button
                        type="button"
                        color="primary"
                        className="waves-effect waves-light"
                        href="/NewCompareQuotation/0"
                      >
                        New Compare
                      </Button>
                    </div>
                  </CardHeader>
                  <CardBody className="pt-0">
                    <AllCompareQuotation />
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <FiltertRightbar />
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
const mapStatetoProps = (state) => {
  const { CQRowList, CQRowListCount, params, loading } = state.CompareQuotation;
  return {
    CQRowList,
    CQRowListCount,
    params,
    loading,
  };
};
export default connect(mapStatetoProps, {
  getCompareQuotationList,
  SetParams,
  FilterClear,
  FiltersShowRightSidebar,
})(CompareQuotationDashboard);
